import { createSlice } from "@reduxjs/toolkit";

export const urlStoreSlice = createSlice({
  name: "url-store",
  initialState: {
    isLoading: false,
    isError: false,
    urlData: [],
    message: "",
  },
  reducers: {
    onPostUrlData: (state) => {
      return {
        ...state,
        isPostLoading: true,
        postUrlData: [],
      };
    },

    onPostUrlDataSuccess: (state, { payload }) => {
      const { postData = [], message = "", status_code = "200" } = payload;

      return {
        ...state,
        isPostLoading: false,
        postUrlData: postData,
        postMessage: message,
        post_status_code: status_code,
      };
    },

    onPostUrlDataError: (state, { payload }) => {
      const { postData = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        postUrlData: postData,
        postMessage: message,
        post_status_code: status_code,
        isPostLoading: false,
      };
    },
    onPostUrlDataReset: (state) => {
      return {
        ...state,
        postUrlData: [],
        postMessage: "",
        post_status_code: null,
      };
    },
    onGetUrlData: (state) => {
      return {
        ...state,
        isGetLoading: true,
        getUrlData: [],
      };
    },

    onGetUrlDataSuccess: (state, { payload }) => {
      const { getData = [], message = "", status_code = "200" } = payload;
      return {
        ...state,
        isGetLoading: false,
        getUrlData: getData,
        getMessage: message,
        get_status_code: status_code,
      };
    },

    onGetUrlDataError: (state, { payload }) => {
      const { getData = [], message = "", status_code = 400 } = payload;
      return {
        ...state,
        getUrlData: getData,
        getMessage: message,
        get_status_code: status_code,
        isGetLoading: false,
      };
    },
    onGetUrlDataReset: (state) => {
      return {
        ...state,
        getUrlData: [],
        getMessage: "",
        get_status_code: null,
        isGetLoading: false,
      };
    },
  },
});

export const {
  onPostUrlData,
  onPostUrlDataSuccess,
  onPostUrlDataError,
  onPostUrlDataReset,
  onGetUrlData,
  onGetUrlDataSuccess,
  onGetUrlDataError,
  onGetUrlDataReset,
} = urlStoreSlice.actions;

export default urlStoreSlice.reducer;
